module.exports = "/assets/0c051f791272ac186400eda295f98e6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/6W.png
// module id = 1100
// module chunks = 0